import { createQueryKeys } from "@lukemorales/query-key-factory";

import { listSupplementalQuestions } from "~/providers/api/supplementalQuestions";
import { ListSupplementalQuestionsRequest } from "~/providers/types/supplementalQuestions";

export const supplementalQuestionsQueryOptionsFactory = createQueryKeys(
  "supplemental-questions",
  {
    list: ({ organizationId }: ListSupplementalQuestionsRequest) => ({
      queryKey: [organizationId],
      queryFn: () => listSupplementalQuestions({ organizationId }),
    }),
  },
);
